import React from 'react';

import { isNull } from 'lodash-es';

import { ICombo, IItem, IPicker, ISanityBlockContent, ISanityImage } from '@rbi-ctg/menu';
import FormatMenuPrice from 'components/menu-utils/format-menu-price';
import { EventName, emitEvent } from 'utils/event-hub';
import { getDefaultPickerSelection, isCombo, isItem, isPicker } from 'utils/menu';
import { AttributeName } from 'utils/performance';
import { routes } from 'utils/routing';

import { ITileClickedEvent, MainMenuObject } from './types';

export const getDescription = (
  option: IPicker | MainMenuObject
): ISanityBlockContent[] | undefined => {
  // @ts-ignore
  return option?.description?.localeRaw;
};

export const getImageFromOption = (option: IPicker | MainMenuObject): ISanityImage => {
  // if (delve(option, 'image.asset._id')) {
  return option.image;
  // }

  // TODO:
  // Right now, we are not using the `images` value from sanity anywhere.
  // Since we're not querying for those values, we aren't typing for those values either.
  //
  // I'm guessing some day we want to use the right images for the platform, so i'm leaving
  // this code here for that day.
  // But as of today, it's not ever ran, and typescript gets angry at it.
  //
  // const platformImgKey = process.env.REACT_APP_RBI_PLATFORM === 'kiosk' ? 'kiosk' : 'app';
  // if (delve(option, `images.${platformImgKey}.asset._ref`)) {
  //   return option.images[platformImgKey];
  // }

  // return delve(option, 'image.asset.url');
};

interface IFormattedCaloriesAndPriceRangeForMenuObject {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (
      menuObject: ICombo | IItem | IPicker | MainMenuObject,
      displayNutritionWithModifiersFromSanity: boolean
    ) => string,
    getPrices: (menuObject: ICombo | IItem | IPicker | MainMenuObject) => React.ReactNode,
    displayNutritionWithModifiersFromSanity?: boolean,
    enableMenuServiceData?: boolean // @TODO: deprecate this when we move to menu-service
  ): { calories: string; price: React.ReactNode };
}

export const formattedCaloriesAndPriceRangeForMenuObject: IFormattedCaloriesAndPriceRangeForMenuObject =
  (
    menuObject,
    getCaloriesRange,
    getPrices,
    displayNutritionWithModifiersFromSanity = false,
    enableMenuServiceData = false
  ) => {
    if (enableMenuServiceData) {
      const price = getPrices(menuObject);
      return {
        calories: getCaloriesRange(menuObject, displayNutritionWithModifiersFromSanity),
        price,
      };
    }

    if (isPicker(menuObject) && menuObject.options) {
      const defaultOption: ICombo | IItem | null = getDefaultPickerSelection(menuObject);

      if (isNull(defaultOption)) {
        return { calories: '', price: '' };
      }

      return formattedCaloriesAndPriceRangeForMenuObject(
        defaultOption,
        getCaloriesRange,
        getPrices,
        displayNutritionWithModifiersFromSanity
      );
    }

    if (isCombo(menuObject) || isItem(menuObject)) {
      const calories = getCaloriesRange(menuObject, displayNutritionWithModifiersFromSanity);
      const price = getPrices(menuObject);

      return { calories, price };
    }

    return { calories: '', price: '' };
  };

interface IGetCaloriesAndPrice {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (
      menuObject: ICombo | IItem,
      displayNutritionWithModifiersFromSanity: boolean
    ) => string,
    displayNutritionWithModifiersFromSanity?: boolean,
    enableMenuServiceData?: boolean
  ): { calories: string; price: React.ReactNode };
}

export const getCaloriesAndPrice: IGetCaloriesAndPrice = (
  menuObject,
  getCaloriesRange,
  displayNutritionWithModifiersFromSanity,
  enableMenuServiceData
) => {
  const getPrices = (comboOrItem: ICombo | IItem) => {
    return <FormatMenuPrice menuItem={comboOrItem} />;
  };

  return formattedCaloriesAndPriceRangeForMenuObject(
    menuObject,
    getCaloriesRange,
    getPrices,
    displayNutritionWithModifiersFromSanity,
    enableMenuServiceData
  );
};

export const emitTileClickedEvent = ({
  sanityId,
  pathname,
  menuServiceDataEnabled,
}: ITileClickedEvent) => {
  emitEvent(EventName.MENU_TILE_CLICKED, {
    sanityId,
    isOnMainMenu: pathname === routes.menu,
    attributes: [
      {
        name: AttributeName.MENU_SERVICE_DATA_ENABLED,
        value: String(menuServiceDataEnabled),
      },
    ],
  });
};
